export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/entitiesRefs.worker.86a4f09f.worker.js");
}
